import React, {useEffect, useRef} from 'react';
import ReactDOM from 'react-dom';
import CategoryItem from "./CategoryItem";
import GammeItem from "./GammeItem";


function GammeContainer({gammes, selectGamme}) {

    return (<div className="gammes-container">
        {
            gammes.map(function(gamme) {
                return <GammeItem selectGamme={selectGamme} key={gamme.id} item={gamme} />
            })
        }
    </div>);
}

export default GammeContainer;
